module.exports = __webpack_public_path__ + "1e2a2409c58001fd0334bc0384f88b79.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/pn.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/pn.svg
// module chunks = 0